
export default (function (config) {
  return _initializeMadeWithBadge(config);
});

var _initializeMadeWithBadge = function _initializeMadeWithBadge(config) {
  if (!config || !config.boostedMetadataId || !GeneralMills.Analytics) return;
  GeneralMills.Analytics.raiseEvent({
    EventType: "MadeWithMetadataImpression",
    BoostedMetadataId: config.boostedMetadataId
  });
};